import $ from 'jquery';

$( function() {
	$( '.wp-block-prj-pt-gutenberg-blocks-accordion .accordion-header' ).on( 'click keydown', function( e ) {
		// if this was a keydown event we only react to "space" and "enter"
		// handle enter (space is handled by default in modern browsers)
		if ( 'keydown' === e.type && 13 !== e.which ) {
			return;
		}
		e.preventDefault();

		const $toggle = $( this );
		if ( 'true' === $toggle.attr( 'aria-expanded' ) ) {
			$toggle.siblings( '.text-wrap' ).slideUp();
			$toggle.attr( 'aria-expanded', 'false' );
		} else {
			$toggle.siblings( '.text-wrap' ).slideDown();
			$toggle.attr( 'aria-expanded', 'true' );
		}
	} );
} );
